import Swal from 'sweetalert2'

// Como usar:
// this.$displayQuestion('Atenção', questionText, 'Sim', 'Não')

export async function displayQuestion (title, text, btnConfirm, btnCancel, cancelMsg, btnConfirmColor, btnCancelColor) {
  const config = {
    title,
    text,
    showCancelButton: true,
    confirmButtonText: btnConfirm || 'Confirmar',
    cancelButtonText: btnCancel || 'Cancelar'
  }

  if (btnConfirmColor) {
    config.confirmButtonColor = btnConfirmColor
  }

  if (btnCancelColor) {
    config.cancelButtonColor = btnCancelColor
  }

  const { value: resposta } = await Swal.fire(config)

  if (resposta) {
    return true
  } else {
    if (cancelMsg) {
      Swal.fire(cancelMsg)
    }
    return false
  }
}
